import React from 'react';
import './QualityBadge.css';

/**
 * QualityBadge component - displays a small badge/flag indicating quality status
 * @param {Object} judgment - Quality judgment object with score, passed, etc.
 * @param {string} agentName - Name of the agent being evaluated
 */
const QualityBadge = ({ judgment, agentName }) => {
  // Don't render if no judgment available
  if (!judgment) {
    return null;
  }

  // Determine badge color based on score and passed status
  const getBadgeColor = (score, passed) => {
    if (passed) {
      return '#23d5ab'; // Green - passed threshold
    }
    if (score >= 5.0) {
      return '#ffd93d'; // Yellow - borderline
    }
    return '#ff6b6b'; // Red - failed
  };

  const badgeColor = getBadgeColor(judgment.score || 0, judgment.passed || false);
  const score = judgment.score ? judgment.score.toFixed(1) : '0.0';

  return (
    <div 
      className="quality-badge-wrapper"
      title={`Quality Score: ${score}/10 - ${judgment.passed ? 'Passed' : 'Failed'}`}
    >
      <div 
        className="quality-badge"
        style={{ backgroundColor: badgeColor }}
        aria-label={`Quality check: ${score}/10`}
      >
        ⚡
      </div>
    </div>
  );
};

export default QualityBadge;



